// src/models/administrativo/ConfigDFe.ts
export class ConfigDFe {
  id: number;
  filialId: number;
  numeroCertificado: string;
  possuiCertificado: boolean;
  certificadoValidade?: string | null;
  idToken: string;
  cscCertificado: string;
  idTokenHml: string;
  cscCertificadoHml: string;
  tpAmb?: number | null;
  serieNFCe?: number | null;
  numDocNFCe?: number | null;
  serieNFe?: number | null;
  numDocNFe?: number | null;
  serieMDFe?: number | null;
  numDocMDFe?: number | null;
  serieMDFeHml?: number | null;
  numDocMDFeHml?: number | null;
  rntrc: string;
  cnpjAutorizadoXML: string;
  urlApiNFSe?: string | null;
  urlApiNFSeHml?: string | null;
  tokenNFSe?: string | null;
  tokenNFSeHml?: string | null;
  serieNFSe?: number | null;
  numDpsNFSe?: number | null;
  serieNFSeHml?: number | null;
  numDpsNFSeHml?: number | null;
  opcaoSimplesNacionalNFSe?: number | null;
  regimeEspecialTributacaoNFSe?: number | null;
  regimeApuracaoSimplesNFSe?: number | null;

  constructor(data: Partial<ConfigDFe> = {}) {
    this.id = data.id ?? 0;
    this.filialId = data.filialId ?? 0;
    this.numeroCertificado = data.numeroCertificado ?? '';
    this.possuiCertificado = data.possuiCertificado ?? false;
    this.certificadoValidade = data.certificadoValidade ?? null;
    this.idToken = data.idToken ?? '';
    this.cscCertificado = data.cscCertificado ?? '';
    this.idTokenHml = data.idTokenHml ?? '';
    this.cscCertificadoHml = data.cscCertificadoHml ?? '';
    this.tpAmb = data.tpAmb ?? null;
    this.serieNFCe = data.serieNFCe ?? null;
    this.numDocNFCe = data.numDocNFCe ?? null;
    this.serieNFe = data.serieNFe ?? null;
    this.numDocNFe = data.numDocNFe ?? null;
    this.serieMDFe = data.serieMDFe ?? null;
    this.numDocMDFe = data.numDocMDFe ?? null;
    this.serieMDFeHml = data.serieMDFeHml ?? null;
    this.numDocMDFeHml = data.numDocMDFeHml ?? null;
    this.rntrc = data.rntrc ?? '';
    this.cnpjAutorizadoXML = data.cnpjAutorizadoXML ?? '';
    this.urlApiNFSe = data.urlApiNFSe ?? null;
    this.urlApiNFSeHml = data.urlApiNFSeHml ?? null;
    this.tokenNFSe = data.tokenNFSe ?? null;
    this.tokenNFSeHml = data.tokenNFSeHml ?? null;
    this.serieNFSe = data.serieNFSe ?? null;
    this.numDpsNFSe = data.numDpsNFSe ?? null;
    this.serieNFSeHml = data.serieNFSeHml ?? null;
    this.numDpsNFSeHml = data.numDpsNFSeHml ?? null;
    this.opcaoSimplesNacionalNFSe = data.opcaoSimplesNacionalNFSe ?? null;
    this.regimeEspecialTributacaoNFSe = data.regimeEspecialTributacaoNFSe ?? null;
    this.regimeApuracaoSimplesNFSe = data.regimeApuracaoSimplesNFSe ?? null;
  }
}
